import React, { Fragment } from "react";
import Label from "./Label";

const Input = passedProps => {
  const { name, required, label, value, ...props } = passedProps;

  return (
    <Fragment>
      <Label htmlFor={name} required={required}>
        {label}
      </Label>
      <input
        className="form-control"
        id={name}
        name={name}
        value={value || ""}
        {...props}
      />
    </Fragment>
  );
};

export default Input;
